import ScraperDashboard from '../components/ScraperDashboard'

export default function CTOLarssonDashboard() {
  return (
    <ScraperDashboard
      source="ctolarsson"
      scrapeEndpoint="/scrape/ctolarsson"
      pageTitle="CTO Larsson Report"
      pageDescription="Weekly multi-asset technical-analysis report from pro.ctolarsson.com — published Fridays."
      triggerLabel="Scrape Latest Report"
      postsLinkPath="/posts?source=ctolarsson"
      itemNounSingular="Report"
      itemNounPlural="Reports"
    />
  )
}
